import ApiBase, { baseUrl } from '.';
import store from '@/store';

export default class ConfigurationApi extends ApiBase {
  constructor() {
    super(`${baseUrl}/api/services/app/Configuration`, store.getters['account/token']);
  }

  getTenantBigLogo(tenancyName) {
    return this.http.get(`${this.baseUrl}/GetTenantBigLogo`, {
      params: {
        tenancyName
      }
    });
  }

  getTenantSmallLogo(tenancyName) {
    return this.http.get(`${this.baseUrl}/GetTenantSmallLogo`, {
      params: {
        tenancyName
      }
    });
  }

  setTenantBigLogo(logoUri) {
    return this.authHttp.post(`${this.baseUrl}/SetTenantBigLogo`, {
      logoUri
    });
  }

  setTenantSmallLogo(logoUri) {
    return this.authHttp.post(`${this.baseUrl}/SetTenantSmallLogo`, {
      logoUri
    });
  }
}
